export default __webpack_public_path__ + "static/media/file.a2a88c7b.png";